// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CashfreeDropInCont_App__BSdRC {
    text-align: center;
    width: 100%;
    height: 100%;
  }
  
  .CashfreeDropInCont_App_header__S6yTB {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  
  }
  
  .CashfreeDropInCont_App_link__GnFYU {
    color: var(--main-text);
  }
  
  @keyframes CashfreeDropInCont_App-logo-spin__tVZyh {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .CashfreeDropInCont_dropin_parent__7pj48 {
    max-width: 500px;
    margin: auto;
    margin-top: 20px;
    height: 95%;
    overflow-y: auto;
  }
  
  .CashfreeDropInCont_order_token__J6Q5Z {
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .CashfreeDropInCont_inputText__IdyIz {
    width: 200px;
  }
  .CashfreeDropInCont_btn_render__krDfn {
    border-radius: 6px;
    background-color: rgb(105, 51, 211);
    color: rgb(255, 255, 255);
    border: none;
    font-size: 14px;
    padding: 11px 16px;
  }
  input {
    padding: 0.67857143em 1em;
    border-radius: 6px;
    border: 1px solid #979797;
  }
  input:focus {
    outline-color: rgb(105, 51, 211);
  }
  
  .CashfreeDropInCont_style_dropin__ytwrr {
    outline: 0;
    border-width: 0 0 1px;
    border-radius: 0px;
  }
  
  .CashfreeDropInCont_style_dropin__ytwrr:focus {
    border-color: rgb(105, 51, 211);
  }
  
  .CashfreeDropInCont_style_container__NQqZT {
    margin-bottom: 8px;
  }
  .CashfreeDropInCont_toppings_list__QDDRm{
    margin-bottom: 1rem;
  }
  .CashfreeDropInCont_warningMessage__Bxm7y{
    color: red;
    font-size: 1rem;
  }
  .CashfreeDropInCont_mr_8__6ee\\+h {
    margin-right: 1rem;
    margin-left: .5rem;
  }
  
  .CashfreeDropInCont_mr_1__Z4BBk {
    margin-right: 1rem;
  }
  
  .CashfreeDropInCont_mt_2__FMmLo {
    margin-top: 2rem;
  }
  .CashfreeDropInCont_mt_1__j6brh{
    margin-top: 1rem;
  }
  .CashfreeDropInCont_mb_1__rHvp0{
    margin-bottom: 1rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/payment/CashfreeDropInCont.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;;EAEd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB","sourcesContent":[".App {\n    text-align: center;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .App_header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  \n  }\n  \n  .App_link {\n    color: var(--main-text);\n  }\n  \n  @keyframes App-logo-spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  .dropin_parent {\n    max-width: 500px;\n    margin: auto;\n    margin-top: 20px;\n    height: 95%;\n    overflow-y: auto;\n  }\n  \n  .order_token {\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n  \n  .inputText {\n    width: 200px;\n  }\n  .btn_render {\n    border-radius: 6px;\n    background-color: rgb(105, 51, 211);\n    color: rgb(255, 255, 255);\n    border: none;\n    font-size: 14px;\n    padding: 11px 16px;\n  }\n  input {\n    padding: 0.67857143em 1em;\n    border-radius: 6px;\n    border: 1px solid #979797;\n  }\n  input:focus {\n    outline-color: rgb(105, 51, 211);\n  }\n  \n  .style_dropin {\n    outline: 0;\n    border-width: 0 0 1px;\n    border-radius: 0px;\n  }\n  \n  .style_dropin:focus {\n    border-color: rgb(105, 51, 211);\n  }\n  \n  .style_container {\n    margin-bottom: 8px;\n  }\n  .toppings_list{\n    margin-bottom: 1rem;\n  }\n  .warningMessage{\n    color: red;\n    font-size: 1rem;\n  }\n  .mr_8 {\n    margin-right: 1rem;\n    margin-left: .5rem;\n  }\n  \n  .mr_1 {\n    margin-right: 1rem;\n  }\n  \n  .mt_2 {\n    margin-top: 2rem;\n  }\n  .mt_1{\n    margin-top: 1rem;\n  }\n  .mb_1{\n    margin-bottom: 1rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `CashfreeDropInCont_App__BSdRC`,
	"App_header": `CashfreeDropInCont_App_header__S6yTB`,
	"App_link": `CashfreeDropInCont_App_link__GnFYU`,
	"dropin_parent": `CashfreeDropInCont_dropin_parent__7pj48`,
	"order_token": `CashfreeDropInCont_order_token__J6Q5Z`,
	"inputText": `CashfreeDropInCont_inputText__IdyIz`,
	"btn_render": `CashfreeDropInCont_btn_render__krDfn`,
	"style_dropin": `CashfreeDropInCont_style_dropin__ytwrr`,
	"style_container": `CashfreeDropInCont_style_container__NQqZT`,
	"toppings_list": `CashfreeDropInCont_toppings_list__QDDRm`,
	"warningMessage": `CashfreeDropInCont_warningMessage__Bxm7y`,
	"mr_8": `CashfreeDropInCont_mr_8__6ee+h`,
	"mr_1": `CashfreeDropInCont_mr_1__Z4BBk`,
	"mt_2": `CashfreeDropInCont_mt_2__FMmLo`,
	"mt_1": `CashfreeDropInCont_mt_1__j6brh`,
	"mb_1": `CashfreeDropInCont_mb_1__rHvp0`,
	"App-logo-spin": `CashfreeDropInCont_App-logo-spin__tVZyh`
};
export default ___CSS_LOADER_EXPORT___;
